/** API status → English label (same tone as Sign in / Add To Cart). */
export const DASHBOARD_STATUS_LABELS = {
	ordered: 'Already ordered',
	not_ordered: 'No order yet',
	cancelled: 'Cancelled',
	inactive: 'Inactive',
};

export function dashboardStatusLabel(status) {
	return DASHBOARD_STATUS_LABELS[status] || status || 'No order yet';
}

export function canOrderForChild(child) {
	if (!child) return false;
	if (child.is_active === false) return false;
	if (child.status === 'inactive') return false;
	return true;
}
